var WebFont = require('webfontloader');

export default {
  init: function () {
    WebFont.load({
      typekit: {
        id: 'kbo1tyu',
      },
      // google: {
      //   families: ['Inter:200,400,500,600,700'],
      // },
      // custom: {
      //   families: ['DIN', 'DIN Condensed', 'DINOT'],
      // },
      // custom: {
      //   families: ['IvarHeadline', 'chlakh']
      // }
      // custom: {
      //     families: ['din:n3,n4,n5,n7,n9', 'dinengschrift:n3,n4,n7'],
      //     urls: ['/wp-content/themes/enve/build/fonts/din.css', '/wp-content/themes/enve/build/fonts/dinengschrift.css']
      // },
      // active: function() {
      //     var event = document.createEvent('Event');
      //     event.initEvent('webfontsready', true, true);
      //     document.dispatchEvent(event);
      //     App.emit("webfontsready");
      // }
    });
  },
};
